/**
 * @module Root
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable:no-any */ // We don't want to build an interface for DevOp configurations
import { environment } from '@environment/environment';

const CONFIG: any = { uiCache: {} };
export const setSettings = (config: any) => {
  SETTINGS = {
    ENV: environment.env,
    PROD: environment.production,
    HMR: environment.hmr,
    CHANNEL: environment.channel || 'retail',
    CONFIG: config,
    CLIENT_ID: config.clientId,
    EUIROOT: config.euiRoot,
    EUIPARAMS: config.euiParams,
    EUISCOPE: config.euiScope,
    EPAY_ENDPOINT: config.epayEndpoint,
    TMO_REDIRECT: config.tmoRedirect,
    GRANTTYPE: config.grantType,
    IAMCLIENTID: config.iamClientId,
    MOCK_ENDPOINT: config.mockEndpoint,
    API_ENDPOINT: config.apiEndPoint,
    GRAND_CENTRAL_URL: config.extGrandCentralUrl,
    AEM_ENDPOINT: config.aemEndPoint,
    MS_ENDPOINT: config.esGatewayEndpoint,
    LISA_ENDPOINT: config.lisaEndpoint,
    MOBILE: config.mobile,
    WEB_WORKER: config.webworker,
    EXT_IMAGE_URL: config.extTmoImagesUrl,
    ISLOGGERENABLE: config.isLoggerEnable,
    LOGGER_ENDPOINT: config.loggerApiEndPoint,
    SAP_CARE_URL: config.sapCareUrl,
    REMEDY_FORM_URL: config.remedyFormUrl,
    UI_CACHE: {
      CUSTOMER_TTL: config.uiCache ? config.uiCache.customerTTL : '',
      CART_TTL: config.uiCache ? config.uiCache.cartTTL : '',
    },
    IS_ERROR_HANDLING_ENABLED: config.isErrorHandlingEnabled,
    IDLEDEFAULTTIMEOUT: config.idleDefaultTimeout,
    TOKEN: config.token,
    BILLINGTYPE: config.billingType,
    APPLICATIONUSERID: config.applicationUserId,
    ROLE: config.role,
    WALKME_SNIPPET: config.walkMeSnippet,
    STACKID: config.stackId,
    IS_NPE: config.isNPE,
    CAPTCHA_SITE_KEY: config.captchaSiteKey,
    INVISIBLE_CAPTCHA_SITE_KEY: config.invisibleCaptchaSiteKey,
    KID: config.kid,
    TOKENEXP: config.tokenExp,
    CLIENT_SECRET: config.clientSecret,
    PROXY_NAMES: config.proxyNames,
    AUTH_CLIENT_ID: config.authClientId,
    SHAPE_ENABLED: config.shapeEnabled,
    PDL_UTAG_URL: config.pdlUtagUrl,
    PDL_ENABLED: config.pdlEnabled,
    ADOBE_URL: config.adobeUrl,
    COVERAGE_MAP_TOKEN: config.coverageMapToken,
    COVERAGE_MAP: config.coverageMap,
  };
};
export const APP_CONSTANTS = {
  isLoggerEnable: 'isLoggerEnable',
};

export const GPC_CONSTS = {
  NAVIGATOR: 'navigator',
  GPC: 'globalPrivacyControl',
  GPC_VAR: 'gpcDNTSet',
  COOKIE_NAME: 'dnt',
};

export const CHANNELS = {
  RETAIL: 'retail',
  WEB: 'web',
  CARE: 'care',
  NRD: 'nrd',
};

// @TODO rename fields to CAP_CASE for consistency
export let SETTINGS = {
  ENV: environment.env,
  PROD: environment.production,
  HMR: environment.hmr,
  CHANNEL: environment.channel,
  CONFIG: CONFIG,
  TMO_REDIRECT: CONFIG.tmoRedirect,
  CLIENT_ID: CONFIG.clientId,
  EUIROOT: CONFIG.euiRoot,
  EUIPARAMS: CONFIG.euiParams,
  EUISCOPE: CONFIG.euiScope,
  GRANTTYPE: CONFIG.grantType,
  IAMCLIENTID: CONFIG.iamClientId,
  MOCK_ENDPOINT: CONFIG.mockEndpoint,
  API_ENDPOINT: CONFIG.apiEndPoint,
  GRAND_CENTRAL_URL: CONFIG.extGrandCentralUrl,
  AEM_ENDPOINT: CONFIG.aemEndPoint,
  MS_ENDPOINT: CONFIG.esGatewayEndpoint,
  LISA_ENDPOINT: CONFIG.lisaEndpoint,
  MOBILE: CONFIG.mobile,
  WEB_WORKER: CONFIG.webworker,
  EXT_IMAGE_URL: CONFIG.extTmoImagesUrl,
  ISLOGGERENABLE: CONFIG.isLoggerEnable,
  LOGGER_ENDPOINT: CONFIG.loggerApiEndPoint,
  SAP_CARE_URL: CONFIG.sapCareUrl,
  EPAY_ENDPOINT: CONFIG.epayEndpoint,
  REMEDY_FORM_URL: CONFIG.remedyFormUrl,
  UI_CACHE: {
    CUSTOMER_TTL: CONFIG.uiCache.customerTTL,
    CART_TTL: CONFIG.uiCache.cartTTL,
  },
  IS_ERROR_HANDLING_ENABLED: CONFIG.isErrorHandlingEnabled,
  IDLEDEFAULTTIMEOUT: CONFIG.idleDefaultTimeout,
  TOKEN: CONFIG.token,
  BILLINGTYPE: CONFIG.billingType,
  APPLICATIONUSERID: CONFIG.applicationUserId,
  ROLE: CONFIG.role,
  WALKME_SNIPPET: CONFIG.walkMeSnippet,
  STACKID: CONFIG.stackId,
  SHAPE_ENABLED: CONFIG.shapeEnabled,
  IS_NPE: CONFIG.isNPE,
  CAPTCHA_SITE_KEY: CONFIG.captchaSiteKey,
  INVISIBLE_CAPTCHA_SITE_KEY: CONFIG.invisibleCaptchaSiteKey,
  KID: CONFIG.kid,
  CLIENT_SECRET: CONFIG.clientSecret,
  PROXY_NAMES: CONFIG.proxyNames,
  AUTH_CLIENT_ID: CONFIG.authClientId,
  TOKENEXP: CONFIG.tokenExp,
  PDL_UTAG_URL: CONFIG.pdlUtagUrl,
  PDL_ENABLED: CONFIG.pdlEnabled,
  ADOBE_URL: CONFIG.adobeUrl,
  COVERAGE_MAP_TOKEN: CONFIG.coverageMapToken,
  COVERAGE_MAP: CONFIG.coverageMap,
};

export let KEYPAIR = {};
export const setKeyPair = (keypair: any) => {
  KEYPAIR = keypair;
};
